// TODO: This needs to be updated whenever we add new INTERFACE types and should be automated in the future
// https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher

// Manual update steps: https://code.corp.surveymonkey.com/thomask/GQLFragmentMatcher

const introspectionQueryResultData = {
  __schema: {
    types: [
      {
        kind: 'INTERFACE',
        name: 'SurveyQuestion',
        possibleTypes: [
          { name: 'PresentationQuestion' },
          { name: 'SingleChoiceQuestion' },
          { name: 'MultipleChoiceQuestion' },
          { name: 'OpenEndedQuestion' },
          { name: 'MatrixQuestion' },
          { name: 'DemographicQuestion' },
          { name: 'ClickMapQuestion' },
          { name: 'DatetimeQuestion' },
          { name: 'BasicQuestion' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'BaseQuestionHeader',
        possibleTypes: [{ name: 'SurveyQuestionHeader' }, { name: 'VideoStimuliSurveyQuestionHeader' }],
      },
      {
        kind: 'INTERFACE',
        name: 'PaginatedList',
        possibleTypes: [
          { name: 'AnalysisStandardViewList' },
          { name: 'RespondentList' },
          { name: 'SurveyRespondentResultsList' },
          { name: 'SurveyQuestionColumnChoiceList' },
          { name: 'SurveyQuestionList' },
          { name: 'CollaboratorList' },
          { name: 'CollectorList' },
          { name: 'CrossTabReportList' },
          { name: 'AnalysisResultsDashboardList' },
          { name: 'SurveyPageList' },
          { name: 'AnalysisSharedViewList' },
          { name: 'SurveyQuestionRowList' },
          { name: 'SurveyQuestionOptionList' },
          { name: 'WordCloudTagList' },
          { name: 'SurveyOtherResponseList' },
          { name: 'TeamImageAssetsList' },
          { name: 'ApplicationListingList' },
          { name: 'LibraryAssetsList' },
          { name: 'SurveyList' },
          { name: 'AnalysisExportJobList' },
          { name: 'SurveyTemplateList' },
          { name: 'SurveyCategoryList' },
          { name: 'SurveyCategoryIdList' },
          { name: 'SurveyTemplateCategoryList' },
          { name: 'SurveyTemplateAttributesList' },
          { name: 'TeamSurveyList' },
          { name: 'SurveyQuestionTemplateList' },
          { name: 'BillingInvoiceList' },
          { name: 'SurveyQuestionColumnList' },
          { name: 'NotificationPreferenceList' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'AnalysisStandardViewFilterRule',
        possibleTypes: [
          { name: 'QnAFilter' },
          { name: 'CollectorFilter' },
          { name: 'QuizScoreBucketsFilter' },
          { name: 'TimePeriodFilter' },
          { name: 'CompletenessFilter' },
          { name: 'RandomAssignmentFilter' },
          { name: 'RelativeTimePeriodFilter' },
          { name: 'ResponseQualityFilter' },
          { name: 'SinceLastInviteFilter' },
          { name: 'TagFilter' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'AnalysisStandardViewCompareRule',
        possibleTypes: [{ name: 'QuestionAndAnswerCompare' }, { name: 'RandomAssignmentCompare' }],
      },
      {
        kind: 'UNION',
        name: 'SurveyRespondentAnswer',
        possibleTypes: [
          { name: 'SurveyChoiceResponse' },
          { name: 'SurveyImageChoiceResponse' },
          { name: 'SurveyOtherResponse' },
          { name: 'SurveyOpenEndedResponse' },
          { name: 'SurveyMatrixResponse' },
          { name: 'SurveyMatrixOtherResponse' },
          { name: 'SurveyMatrixDropDownResponse' },
          { name: 'SurveyMatrixOpenEndedResponse' },
          { name: 'SurveyFileUploadResponse' },
          { name: 'SurveyPaymentResponse' },
          { name: 'SurveyPresentationImageResponse' },
          { name: 'SurveyPresentationTextResponse' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'SurveyQuestionOption',
        possibleTypes: [
          { name: 'SurveyQuestionRow' },
          { name: 'SurveyQuestionOther' },
          { name: 'SurveyQuestionColumn' },
          { name: 'SurveyQuestionColumnChoice' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Project',
        possibleTypes: [{ name: 'ConceptTestingProject' }],
      },
      {
        kind: 'INTERFACE',
        name: 'ProjectVariableConfiguration',
        possibleTypes: [
          { name: 'DefaultConfiguration' },
          { name: 'ImageStimuliVariableConfiguration' },
          { name: 'TextStimuliVariableConfiguration' },
          { name: 'VideoStimuliVariableConfiguration' },
          { name: 'ProductStimuliVariableConfiguration' },
          { name: 'NormsVariableConfiguration' },
          { name: 'AttributesVariableConfiguration' },
          { name: 'StimuliComparisonQuestionVariableConfiguration' },
          { name: 'CustomQuestionsBeforeStimuliVariableConfiguration' },
          { name: 'CustomQuestionsAfterStimuliVariableConfiguration' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'ProjectVariableAnswer',
        possibleTypes: [
          { name: 'QuestionVariableAnswer' },
          { name: 'QuestionBankVariableAnswer' },
          { name: 'ValueVariableAnswer' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'ConceptTestingStimulus',
        possibleTypes: [{ name: 'ConceptTestingTextStimulus' }, { name: 'ConceptTestingImageStimulus' }],
      },
      {
        kind: 'UNION',
        name: 'AttributeQuestion',
        possibleTypes: [
          { name: 'SingleChoiceQuestion' },
          { name: 'MultipleChoiceQuestion' },
          { name: 'OpenEndedQuestion' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'QuestionResponseSummary',
        possibleTypes: [
          { name: 'OneDimensionalResponseSummary' },
          { name: 'TwoDimensionalResponseSummary' },
          { name: 'ThreeDimensionalResponseSummary' },
        ],
      },
      {
        kind: 'UNION',
        name: 'MultipleComparisonQuestion',
        possibleTypes: [{ name: 'MultipleChoiceQuestion' }, { name: 'SingleChoiceQuestion' }],
      },
      {
        kind: 'UNION',
        name: 'CustomQuestion',
        possibleTypes: [
          { name: 'SingleChoiceQuestion' },
          { name: 'MultipleChoiceQuestion' },
          { name: 'OpenEndedQuestion' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'ProjectEntity',
        possibleTypes: [{ name: 'ProjectAudienceCollectorEntity' }, { name: 'ProjectSurveyEntity' }],
      },
      {
        kind: 'INTERFACE',
        name: 'AudienceTargetingCriteria',
        possibleTypes: [
          { name: 'AudienceRangeCriteria' },
          { name: 'AudienceCategoricalCriteria' },
          { name: 'AudienceHouseholdIncomeRangeCriteria' },
        ],
      },
      {
        kind: 'UNION',
        name: 'AudienceCriteriaSelection',
        possibleTypes: [
          { name: 'AudienceCategoricalCriteriaSelection' },
          { name: 'AudienceRangeCriteriaSelection' },
          { name: 'AudienceHouseholdIncomeRangeCriteriaSelection' },
        ],
      },
      {
        kind: 'UNION',
        name: 'CustomQuestionResponseSummary',
        possibleTypes: [
          { name: 'CustomQuestionAggregateResponseSummary' },
          { name: 'CustomQuestionStimuliResponseSummary' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'ImageAsset',
        possibleTypes: [{ name: 'TeamImageAsset' }],
      },
      {
        kind: 'INTERFACE',
        name: 'TeamAsset',
        possibleTypes: [{ name: 'TeamImageAsset' }],
      },
      {
        kind: 'INTERFACE',
        name: 'Asset',
        possibleTypes: [{ name: 'TeamImageAsset' }],
      },
      {
        kind: 'INTERFACE',
        name: 'LibraryAsset',
        possibleTypes: [
          { name: 'LibraryImage' },
          { name: 'LibraryTheme' },
          { name: 'LibraryCustomQuestion' },
          { name: 'LibrarySurveyTemplate' },
          { name: 'LibraryDocument' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'WelcomeFlowQuestion',
        possibleTypes: [
          { name: 'WelcomeFlowSingleChoiceQuestion' },
          { name: 'WelcomeFlowMultipleChoiceQuestion' },
          { name: 'WelcomeFlowFlagQuestion' },
          { name: 'WelcomeFlowNumberQuestion' },
          { name: 'WelcomeFlowTextQuestion' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'SurveyQuestionTemplate',
        possibleTypes: [
          { name: 'BasicQuestionTemplate' },
          { name: 'SingleChoiceQuestionTemplate' },
          { name: 'MatrixQuestionTemplate' },
          { name: 'OpenEndedQuestionTemplate' },
          { name: 'DemographicQuestionTemplate' },
          { name: 'MultipleChoiceQuestionTemplate' },
          { name: 'ClickMapQuestionTemplate' },
          { name: 'DatetimeQuestionTemplate' },
          { name: 'PresentationQuestionTemplate' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'QuestionVariableAnswerData',
        possibleTypes: [
          { name: 'DefaultQuestionVariableAnswerData' },
          { name: 'ABQuestionVariableAnswerData' },
          { name: 'VideoABQuestionVariableAnswerData' },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'SurveyQuestionTemplateOption',
        possibleTypes: [
          { name: 'SurveyQuestionTemplateRow' },
          { name: 'SurveyQuestionTemplateOther' },
          { name: 'SurveyQuestionTemplateColumn' },
          { name: 'SurveyQuestionTemplateColumnChoice' },
        ],
      },
    ],
  },
};

export default introspectionQueryResultData;
